"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldAggregationTypeEnum;
(function (TableauNlpSemanticmodelFieldAggregationTypeEnum) {
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Unspecified"] = "AGGREGATIONTYPE_UNSPECIFIED";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Average"] = "AGGREGATIONTYPE_AVERAGE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Countdistinct"] = "AGGREGATIONTYPE_COUNTDISTINCT";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Count"] = "AGGREGATIONTYPE_COUNT";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Max"] = "AGGREGATIONTYPE_MAX";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Min"] = "AGGREGATIONTYPE_MIN";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Percentile"] = "AGGREGATIONTYPE_PERCENTILE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Standarddeviationpop"] = "AGGREGATIONTYPE_STANDARDDEVIATIONPOP";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Standarddeviation"] = "AGGREGATIONTYPE_STANDARDDEVIATION";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Sum"] = "AGGREGATIONTYPE_SUM";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Variancepop"] = "AGGREGATIONTYPE_VARIANCEPOP";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Variance"] = "AGGREGATIONTYPE_VARIANCE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["None"] = "AGGREGATIONTYPE_NONE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Median"] = "AGGREGATIONTYPE_MEDIAN";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Collect"] = "AGGREGATIONTYPE_COLLECT";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Corr"] = "AGGREGATIONTYPE_CORR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Covar"] = "AGGREGATIONTYPE_COVAR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Covarp"] = "AGGREGATIONTYPE_COVARP";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Attribute"] = "AGGREGATIONTYPE_ATTRIBUTE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["User"] = "AGGREGATIONTYPE_USER";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Sumxsqr"] = "AGGREGATIONTYPE_SUMXSQR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncYear"] = "AGGREGATIONTYPE_TRUNC_YEAR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncQtr"] = "AGGREGATIONTYPE_TRUNC_QTR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncMonth"] = "AGGREGATIONTYPE_TRUNC_MONTH";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncWeek"] = "AGGREGATIONTYPE_TRUNC_WEEK";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncDay"] = "AGGREGATIONTYPE_TRUNC_DAY";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncHour"] = "AGGREGATIONTYPE_TRUNC_HOUR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncMinute"] = "AGGREGATIONTYPE_TRUNC_MINUTE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["TruncSecond"] = "AGGREGATIONTYPE_TRUNC_SECOND";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Unknown"] = "AGGREGATIONTYPE_UNKNOWN";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Year"] = "AGGREGATIONTYPE_YEAR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Qtr"] = "AGGREGATIONTYPE_QTR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Month"] = "AGGREGATIONTYPE_MONTH";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Week"] = "AGGREGATIONTYPE_WEEK";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Day"] = "AGGREGATIONTYPE_DAY";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Hour"] = "AGGREGATIONTYPE_HOUR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Minute"] = "AGGREGATIONTYPE_MINUTE";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Second"] = "AGGREGATIONTYPE_SECOND";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Weekday"] = "AGGREGATIONTYPE_WEEKDAY";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Monthyear"] = "AGGREGATIONTYPE_MONTHYEAR";
    TableauNlpSemanticmodelFieldAggregationTypeEnum["Monthday"] = "AGGREGATIONTYPE_MONTHDAY";
})(TableauNlpSemanticmodelFieldAggregationTypeEnum = exports.TableauNlpSemanticmodelFieldAggregationTypeEnum || (exports.TableauNlpSemanticmodelFieldAggregationTypeEnum = {}));
function TableauNlpSemanticmodelFieldAggregationFromJSON(json) {
    return TableauNlpSemanticmodelFieldAggregationFromJSONTyped(json, false);
}
exports.TableauNlpSemanticmodelFieldAggregationFromJSON = TableauNlpSemanticmodelFieldAggregationFromJSON;
function TableauNlpSemanticmodelFieldAggregationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'value': !runtime_1.exists(json, 'value') ? undefined : json['value'],
    };
}
exports.TableauNlpSemanticmodelFieldAggregationFromJSONTyped = TableauNlpSemanticmodelFieldAggregationFromJSONTyped;
function TableauNlpSemanticmodelFieldAggregationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'value': value.value,
    };
}
exports.TableauNlpSemanticmodelFieldAggregationToJSON = TableauNlpSemanticmodelFieldAggregationToJSON;
